import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      <section className="home-hero">
        <div className="container">
          <div className="home-hero-grid">
            <div className="home-hero-copy">
              <h1>Study. Practice. Win.</h1>
              <p>
                Find proven chess lessons by level, turn ideas into practical plans, and
                build real game confidence with structured training.
              </p>
              <Link to="/videos" className="btn btn-primary home-hero-cta">
                Start Your Free Trial
              </Link>
              <span className="home-hero-subtext">7 day free trial - Cancel anytime</span>
            </div>

            <div className="home-hero-visual">
              <div className="dashboard-card">
                <div className="dashboard-sidebar">
                  <div className="dash-brand">SmartChess</div>
                  <div className="dash-item active">Create Study Plan</div>
                  <div className="dash-item">Dashboard</div>
                  <div className="dash-item">Video Library</div>
                  <div className="dash-item">Tactics</div>
                  <div className="dash-item">Game Review</div>
                </div>
                <div className="dashboard-main">
                  <h3>Training Dashboard</h3>
                  <div className="dash-stat-grid">
                    <div className="dash-stat">
                      <span>Current Streak</span>
                      <strong>12 Days</strong>
                    </div>
                    <div className="dash-stat">
                      <span>Lessons Complete</span>
                      <strong>38</strong>
                    </div>
                    <div className="dash-stat">
                      <span>Tactical Rating</span>
                      <strong>1720</strong>
                    </div>
                    <div className="dash-stat">
                      <span>Weekly Progress</span>
                      <strong>+14%</strong>
                    </div>
                  </div>
                  <div className="dash-panel" />
                  <div className="dash-panel short" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section home-features-section">
        <div className="container">
          <h2 className="section-title">Why Choose Smart Chess?</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🎯</div>
              <h3 className="feature-title">Structured Learning</h3>
              <p className="feature-description">
                Our curriculum is designed to take you from beginner to advanced, with clear progression paths and skill assessments.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">👨‍🏫</div>
              <h3 className="feature-title">Expert Instructors</h3>
              <p className="feature-description">
                Learn from international masters and grandmasters who share their insights and strategies.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📱</div>
              <h3 className="feature-title">Learn Anywhere</h3>
              <p className="feature-description">
                Access our video library on any device, anytime. Perfect for learning on the go or during your commute.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section home-learning-section">
        <div className="container">
          <h2 className="section-title">What You'll Learn</h2>
          <div className="learning-areas">
            <div className="learning-area">
              <h3>Opening Strategies</h3>
              <p>Master essential openings, understand their principles, and build a solid foundation for your games.</p>
            </div>
            <div className="learning-area">
              <h3>Tactical Patterns</h3>
              <p>Develop your tactical vision with puzzles, combinations, and pattern recognition exercises.</p>
            </div>
            <div className="learning-area">
              <h3>Strategic Thinking</h3>
              <p>Learn to evaluate positions, plan long-term strategies, and understand positional play.</p>
            </div>
            <div className="learning-area">
              <h3>Endgame Mastery</h3>
              <p>Convert advantages into wins with essential endgame techniques and principles.</p>
            </div>
          </div>
          <div style={{ textAlign: 'center', marginTop: '40px' }}>
            <Link to="/videos" className="btn btn-primary">
              Start Learning Today
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home; 